import { render, staticRenderFns } from "./SettingsEditViewTermRegistration.vue?vue&type=template&id=5b29a59e"
import script from "./SettingsEditViewTermRegistration.vue?vue&type=script&lang=js"
export * from "./SettingsEditViewTermRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports